import { apiGet } from "../baseApi";
import { setTag } from "service/mapper";

export const getList = async ({params}) => {
  try {
    const response = await apiGet("_tag", params);
    return { ...response, rowData: (Array.isArray(response.data?.tags) ? response.data.tags : []).map((el) => setTag(el)) };
  } catch (error) {
    return Promise.reject(error);
  }
};
